import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../../../utils';
import { createCompanyCodeTranslation, createCompanyCodeTranslationArray, getCompanyCodeTranslation } from '../../../graphql';
import type {
  CreateCompanyCodeTranslationMutation,
  CreateCompanyCodeTranslationMutationVariables,
  CreateCompanyCodeTranslationArrayMutation,
  CreateCompanyCodeTranslationArrayMutationVariables,
  GetCompanyCodeTranslationQuery,
  GetCompanyCodeTranslationQueryVariables,
} from '../../../graphql/API';
import { UnitRowDataApi } from '../../CompanycodeTranslation/components/UnitRowData';

export const unitApi = createApi({
  reducerPath: 'unitApi',
  baseQuery: baseQuery,
  tagTypes: ['unitSettings'],
  endpoints: (builder) => ({
    listUnits: builder.query<UnitRowDataApi[], GetCompanyCodeTranslationQueryVariables>({
      query: (variables) => ({
        body: getCompanyCodeTranslation,
        variables,
      }),
      keepUnusedDataFor: 1,
      providesTags: ['unitSettings'],
      transformResponse: (response: GetCompanyCodeTranslationQuery) => {
        console.log('unit.api transformResponse - response:', response.getCompanyCodeTranslation);

        type CompanyCodeTranslationItem = NonNullable<NonNullable<GetCompanyCodeTranslationQuery['getCompanyCodeTranslation']>[number]>;
        const transformed: UnitRowDataApi[] =
          response?.getCompanyCodeTranslation
            ?.filter((item): item is CompanyCodeTranslationItem => item !== null && item !== undefined)
            .map((item): UnitRowDataApi => ({
              codetext: item?.codetext || '',
              uqc: item?.uqc || item?.language || '',
              codevalue: item?.codevalue ? Number(item.codevalue) : null,
              language: item?.language || item?.uqc || null,
              raw: item,
            })) || [];

        return transformed;
      },
    }),
    createCompanyCodeTranslation: builder.mutation<CreateCompanyCodeTranslationMutation, CreateCompanyCodeTranslationMutationVariables>({
      query: (variables) => ({
        body: createCompanyCodeTranslation,
        variables,
      }),
      invalidatesTags: ['unitSettings'],
    }),
    createCompanyCodeTranslationArray: builder.mutation<
      CreateCompanyCodeTranslationArrayMutation,
      CreateCompanyCodeTranslationArrayMutationVariables
    >({
      query: (variables) => ({
        body: createCompanyCodeTranslationArray,
        variables,
      }),
      invalidatesTags: ['unitSettings'],
    }),
  }),
});

export const { 
  useListUnitsQuery,
  useLazyListUnitsQuery,
  usePrefetch,
  useCreateCompanyCodeTranslationMutation,
  useCreateCompanyCodeTranslationArrayMutation 
} = unitApi;
